<template>
  <div v-if="password.length > 0" class="password-strength-container">
    <div class="strength-bar">
      <div class="strength-progress" :style="{ width: strength.percentage + '%', backgroundColor: strength.color }"></div>
    </div>
    <div class="strength-label">
      <span class="strength-text" :style="{ color: strength.color }">{{ strength.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordStrengthBar',
  props: {
    password: {
      type: String,
      required: true
    }
  },
  computed: {
    strength() {
      const score = this.calculatePasswordStrength(this.password);

      if (score === 0) return { percentage: 0, color: '#DDD', label: 'No Password' };
      if (score < 30) return { percentage: 20, color: '#F25F5C', label: 'Weak' };
      if (score < 60) return { percentage: 50, color: '#FFE066', label: 'Medium' };
      if (score < 80) return { percentage: 75, color: '#70C1B3', label: 'Strong' };
      return { percentage: 100, color: '#45B69C', label: 'Very Strong' };
    }
  },
  methods: {
    calculatePasswordStrength(password) {
      if (!password) return 0;

      let score = 0;

      // Length - primary factor
      score += Math.min(password.length * 4, 25);

      // Uppercase letters
      const uppercaseCount = (password.match(/[A-Z]/g) || []).length;
      score += uppercaseCount * 3;

      // Lowercase letters
      const lowercaseCount = (password.match(/[a-z]/g) || []).length;
      score += lowercaseCount * 2;

      // Numbers
      const numberCount = (password.match(/[0-9]/g) || []).length;
      score += numberCount * 4;

      // Special characters
      const specialCount = (password.match(/[^A-Za-z0-9]/g) || []).length;
      score += specialCount * 5;

      // Bonus for mixing character types
      let typesCount = 0;
      if (uppercaseCount > 0) typesCount++;
      if (lowercaseCount > 0) typesCount++;
      if (numberCount > 0) typesCount++;
      if (specialCount > 0) typesCount++;

      score += typesCount * 10;

      return Math.min(score, 100);
    }
  }
};
</script>

<style scoped>
.password-strength-container {
  margin: 2px 0;
  height: 20px;
}

.strength-bar {
  height: 3px;
  background-color: rgba(0, 0, 0, 0.08);
  border-radius: 1.5px;
  overflow: hidden;
  margin-bottom: 2px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.strength-progress {
  height: 100%;
  transition: width 0.2s ease-out, background-color 0.2s ease-out;
}

.strength-label {
  display: flex;
  justify-content: flex-end;
}

.strength-text {
  font-size: 10px;
  font-weight: 500;
  transition: color 0.2s ease-out;
}
</style>
